import React from 'react';
import { Placeholder } from '@lmn/design-system';
import { css } from 'styled-components';
import { MobileFlightPlaceholder } from '@/app/components/hotel-detail/changeTransport/ChangeTransportModalPlaceholders';

const TransportSectionSkeleton = (props: { isDesktop: boolean }) =>
  props.isDesktop ? <TransportSectionSkeletonDesktop /> : <TransportSectionSkeletonMobile />;

const TransportSectionSkeletonDesktop = () => (
  <div
    css={css`
      display: flex;
      flex-direction: row;
      border-radius: 8px;
      background-color: ${({ theme }) => theme.kallisto.color.background.static.backgroundLayer02};
      box-shadow: ${({ theme }) => theme.kallisto.shadow.mediumDownShadow};
    `}
  >
    <div
      css={css`
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 168px;
        padding: 20px 24px;
        flex-grow: 1;
      `}
    >
      <TransportRow />
      <TransportRow />
    </div>
    <div
      css={css`
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        justify-content: space-between;
        padding: 16px;
        height: 100%;
        width: 206px;
        box-shadow: ${({ theme }) => theme.kallisto.shadow.mediumDownShadow};
      `}
    >
      <Placeholder height="20px" width="80px" />
      <Placeholder height="32px" width="108px" />
    </div>
  </div>
);

const TransportSectionSkeletonMobile = () => (
  <div
    css={css`
      display: flex;
      flex-direction: column;
      border-radius: 8px;
      background-color: ${({ theme }) => theme.kallisto.color.background.static.backgroundLayer02};
    `}
  >
    <MobileFlightPlaceholder />
    <div
      css={`
        display: flex;
        align-items: center;
        justify-content: flex-end;
        height: 46px;
        padding-right: 24px;
      `}
    >
      <Placeholder height="20px" width="75px" />
    </div>
  </div>
);

const TransportRow = () => (
  <div
    css={`
      display: flex;
      align-items: center;
      width: 100%;
      gap: 16px;
    `}
  >
    <Placeholder height="40px" width="40px" />
    <div
      css={`
        display: flex;
        flex-direction: column;
        gap: 4px;
        flex-grow: 1;
      `}
    >
      <div
        css={`
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          width: 100%;
          min-width: 200px;
        `}
      >
        <Placeholder height="20px" width="60%" />
        <Placeholder height="16px" width="18%" />
        <Placeholder height="16px" width="18%" />
      </div>
      <Placeholder height="16px" width="100%" />
    </div>
    <Placeholder height="16px" width="60px" />
  </div>
);

export default TransportSectionSkeleton;
